import { useState } from "react";
import XIcon from "../../../img/svg/xIcon";
import ReviewStars from "../../core/reviewStars";
import LoadingBalls from "../../core/loadingBalls";
import { addDoc, collection, getDocs, query, serverTimestamp, where } from "firebase/firestore";
import { db } from "../../../firebase";
import { useAuth } from "../../../context/authProvider";

export default function ReviewModal({ watch, close, refresh }: { watch: { [key: string]: any; id: string; }, close: () => void, refresh: () => void }) {

    const { userId } = useAuth();

    const [rate, setRate] = useState(5);
    const [review, setReview] = useState("");
    const [maxLen, setMaxLen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleReview = (value: string) => {
        if(value.length > 152){
            setMaxLen(true);
            return null;
        }
        setReview(value);
        setMaxLen(false);
    }

    const sendReview = async () => {
        try{
            setLoading(true);
            setError(false);
            const q = query(collection(db, "reviews"), where("watch", "==", watch.id));
            const docsSnap = await getDocs(q);
            if (!docsSnap.empty) {
                setError(true);
                return null;
            }
            await addDoc(collection(db, "reviews"), {
                userId,
                watch: watch.id,
                advertiser: watch.advertiser,
                rate,
                review,
                createdAt: serverTimestamp(),
                hidden: false
            })
            refresh();
            close();
            setLoading(false);
        }catch(error){
            console.log(error);
            setLoading(false);
            setError(true);
        }
    }

    return (
        <div onClick={close} className="fixed z-[120] inset-0 bg-primary/60 backdrop-blur-sm flex items-center justify-center p-4 animate-superfade">
            <div onClick={e => e.stopPropagation()} className="w-full max-w-xl bg-white rounded-3xl shadow-2xl relative overflow-hidden flex flex-col">
                <div className="flex justify-between items-center p-6 border-b border-surface bg-white">
                    <h3 className="font-black tracking-widest text-primary uppercase">Avalie Sua Compra</h3>
                    <button onClick={close} className="p-2 hover:bg-moninho rounded-full transition-colors font-bold text-mono">
                        <XIcon fill="currentColor" width="16px" />
                    </button>
                </div>
                
                <div className="p-8 space-y-8 overflow-y-auto max-h-[80vh]">
                    <div className="text-center space-y-2">
                        <p className="text-[10px] sm:text-xs font-bold text-mono tracking-[0.2em] uppercase">
                            {watch.brand} | {watch.year}
                        </p>
                        <h2 className="text-2xl font-black text-primary leading-tight">
                            {watch.model.toUpperCase()}
                        </h2>
                    </div>

                    <div className="flex justify-center bg-moninho py-4 rounded-2xl">
                        <ReviewStars rate={rate} setRate={setRate}/>
                    </div>

                    <div className="space-y-4">
                        <p className="text-xs font-bold text-mono uppercase tracking-widest text-center">Escreva uma avaliação sobre a peça e o vendedor</p>
                        <textarea 
                            value={review} 
                            onChange={e => handleReview(e.target.value)} 
                            className="w-full h-[120px] resize-none bg-white border-2 border-surface focus:border-secondary focus:ring-0 rounded-2xl p-4 text-primary font-medium tracking-wide transition-colors outline-none"
                            placeholder="Sua experiência foi boa?"
                        />
                        {
                            maxLen &&
                            <p className="text-red-500 text-xs text-center font-bold tracking-widest uppercase">Limite de caracteres atingido!</p>
                        }
                        {
                            error &&
                            <p className="text-red-500 text-xs text-center font-bold tracking-widest uppercase">Não foi possível enviar a avaliação</p>
                        }
                    </div>

                    <div className="flex justify-end gap-3 pt-4">
                        {
                            loading ?
                            <div className="h-12 w-32 flex items-center justify-center">
                                <LoadingBalls/>
                            </div>
                            :
                            <>
                                <button 
                                    className="px-6 py-3 bg-white border border-surface text-mono font-bold tracking-widest text-[10px] rounded-xl hover:border-primary hover:text-primary transition-all active:scale-95 uppercase" 
                                    onClick={close}
                                >
                                    Cancelar
                                </button>
                                <button 
                                    className="px-8 py-3 bg-secondary text-white font-black tracking-widest text-[10px] rounded-xl hover:opacity-90 transition-all active:scale-95 uppercase shadow-md shadow-secondary/20" 
                                    onClick={sendReview}
                                >
                                    Avaliar
                                </button>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
